module.exports = __webpack_public_path__ + "img/logo-white.37da56fd.svg";